module.exports = __webpack_public_path__ + "img/BG121884560.df80ae9a.png";